module.exports = __webpack_public_path__ + "img/warning-yellow.d1b7d74e.png";